import { TransformDate } from '../../../shared/decorators/transform-date.decorator';

/**
 * Asset availability params
 */
export class AssetAvailabilityParams {
	/**
	 * Date from
	 */
	@TransformDate()
	dateFrom?: Date;

	/**
	 * Date to
	 */
	@TransformDate()
	dateTo?: Date;
}
